import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAdminSession } from './stores/session';

const routes: RouteRecordRaw[] = [
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import('./views/SignInView.vue'),
    meta: { public: true, chrome: false },
  },
  { path: '/', name: 'overview', component: () => import('./views/OverviewView.vue') },
  { path: '/fleet', name: 'fleet', component: () => import('./views/FleetView.vue') },
  {
    path: '/accelerators',
    name: 'accelerators',
    component: () => import('./views/AcceleratorsView.vue'),
  },
  { path: '/pods', name: 'pods', component: () => import('./views/PodsView.vue') },
  { path: '/accounts', name: 'accounts', component: () => import('./views/AccountsView.vue') },
  { path: '/revenue', name: 'revenue', component: () => import('./views/RevenueView.vue') },
  {
    path: '/billing-settings',
    name: 'billing-settings',
    component: () => import('./views/BillingSettingsView.vue'),
  },
  { path: '/audit', name: 'audit', component: () => import('./views/AuditView.vue') },
  { path: '/security', name: 'security', component: () => import('./views/SecurityView.vue') },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: { name: 'overview' },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: (_to, _from, saved) => saved ?? { top: 0 },
});

router.beforeEach(async (to) => {
  const session = useAdminSession();
  if (session.status === 'unknown') await session.refresh();

  if (to.meta.public === true) {
    // A signed-in staff member landing on sign-in goes straight through.
    return session.status === 'staff' ? { name: 'overview' } : true;
  }

  // A valid customer session that lacks staff roles is turned away rather than shown an
  // empty dashboard — the distinction matters for support triage.
  if (session.status !== 'staff') {
    return {
      name: 'sign-in',
      query: { reason: session.status === 'authenticated' ? 'not-staff' : '' },
    };
  }

  return true;
});
